module.exports = __webpack_public_path__ + "img/methodBlue.c06c82dd.jpg";